var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Selector"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm.rm
                    ? _c("div", [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("Risk adjusted benefits:")]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.rm.ApplyBenefitsConfidenceFactor,
                                  expression:
                                    "rm.ApplyBenefitsConfidenceFactor",
                                },
                              ],
                              staticClass: "form-control",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.rm,
                                    "ApplyBenefitsConfidenceFactor",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { domProps: { value: true } }, [
                                _vm._v("Enabled"),
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: false } }, [
                                _vm._v("Disabled"),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("table", { staticClass: "table table-bordered" }, [
                          _c(
                            "tbody",
                            [
                              _vm._m(0),
                              _vm._v(" "),
                              _vm._l(_vm.rm.Resources, function (r) {
                                return _c("tr", { key: r.Id }, [
                                  _c("td", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(r.Name)
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(_vm._s(r.Unit)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.number",
                                          value: r.Capacity,
                                          expression: "r.Capacity",
                                          modifiers: { number: true },
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "number" },
                                      domProps: { value: r.Capacity },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            r,
                                            "Capacity",
                                            _vm._n($event.target.value)
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                  ]),
                                ])
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", [
                              _c("th", [_vm._v("Budget")]),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass: "text-center",
                                  staticStyle: { width: "250px" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        Limit "
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(_vm._s(_vm.rm.CurrencyLabel)),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n                                        Total cost\n                                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value: _vm.rm.TotalCost,
                                      expression: "rm.TotalCost",
                                      modifiers: { number: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number" },
                                  domProps: { value: _vm.rm.TotalCost },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.rm,
                                        "TotalCost",
                                        _vm._n($event.target.value)
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n                                        Capex\n                                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value: _vm.rm.Capex,
                                      expression: "rm.Capex",
                                      modifiers: { number: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number" },
                                  domProps: { value: _vm.rm.Capex },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.rm,
                                        "Capex",
                                        _vm._n($event.target.value)
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n                                        Opex\n                                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value: _vm.rm.Opex,
                                      expression: "rm.Opex",
                                      modifiers: { number: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number" },
                                  domProps: { value: _vm.rm.Opex },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.rm,
                                        "Opex",
                                        _vm._n($event.target.value)
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n                                        Other expenses\n                                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value: _vm.rm.Othex,
                                      expression: "rm.Othex",
                                      modifiers: { number: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number" },
                                  domProps: { value: _vm.rm.Othex },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.rm,
                                        "Othex",
                                        _vm._n($event.target.value)
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n                                        Expenses (All)\n                                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value: _vm.rm.Expenses,
                                      expression: "rm.Expenses",
                                      modifiers: { number: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number" },
                                  domProps: { value: _vm.rm.Expenses },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.rm,
                                        "Expenses",
                                        _vm._n($event.target.value)
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n                                        Expenses (Opex)\n                                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value: _vm.rm.OpexExpenses,
                                      expression: "rm.OpexExpenses",
                                      modifiers: { number: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number" },
                                  domProps: { value: _vm.rm.OpexExpenses },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.rm,
                                        "OpexExpenses",
                                        _vm._n($event.target.value)
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { type: "button" },
                      on: { click: _vm.handleOptimizeSelectionCommand },
                    },
                    [
                      _c("i", {
                        staticClass: "fa-solid fa-robot fa-bounce mr-1",
                      }),
                      _vm._v(" Optimize now\n                    "),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("tr", [
      _c("th", [_vm._v("Resource")]),
      _vm._v(" "),
      _c(
        "th",
        { staticClass: "text-center", staticStyle: { width: "250px" } },
        [_vm._v("Limit")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }